import {
  colors,
  IGiftItemResponse,
  IOrganisationResponse,
  ItemGridContainer,
  limitChars,
  OrganisationFormat,
} from '@one-tree/library'
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import {
  ExampleGiftItem,
  ExamplePromoGiftItem,
  ExampleSpecialOfferItem,
  ExampleTicketItem,
} from './ExampleGiftItem'

const Preview = styled(ItemGridContainer)`
  width: 287px;
  height: fit-content;
  border: 1px solid ${colors.lightGray};
`

type Props = {
  values: IOrganisationResponse
  withPromo?: true
}
export default function ItemPreview(props: Props): ReactElement {
  const { values, withPromo } = props

  const exampleItems: Record<OrganisationFormat, IGiftItemResponse> = {
    [OrganisationFormat.Tickets]: ExampleTicketItem,
    [OrganisationFormat.SpecialOffers]: ExampleSpecialOfferItem,
    [OrganisationFormat.GiftVouchers]: withPromo
      ? ExamplePromoGiftItem
      : ExampleGiftItem,
  }

  return (
    <Preview
      giftItems={[exampleItems[values.format] ?? ExampleGiftItem]}
      currency={values.currencyCode}
      organisationColors={values}
      font={values.font}
      introductoryText={limitChars(values.introductoryText || '', 50, true)}
      introductoryTextSize={values.textOnBackgroundSize}
    />
  )
}
